<template>
    <div class="order-handle-dialog-operate">
        <pt-form-item label="上传突变验证报告:" label-width="135px" lineHeight="50" :required="true">
            <el-upload ref="file" class="upload-demo" v-model="form.file" name="file" v-validate="'required'" data-vv-as="上传突变验证报告"
            action="aaa"
            :auto-upload="false"
            :multiple="false"
            :on-change="changHandler" :on-remove="removeHandler">
            <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </pt-form-item>
    </div>
</template>

<script>
import { validate } from 'utils/validate'
export default {
  data () {
    return {
      // uploadApi: this.$uploadApi,
      // privateResourcesUrl: this.$privateResourcesUrl,
      // file_params: {
      //   resourceName: 'mutationVerify',
      //   objectId: '突变验证文件'
      // },
      form: {
        file: ''
      }
    }
  },
  watch: {
    form: {
      handler: function (val) {
        console.log('val--------', val)
        this.$emit('input', val)
      },
      deep: true
    }
  },
  components: {

  },
  methods: {
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      console.log('file', file)
      this.form.file = file.raw
    },
    removeHandler (file, fileList) {
      this.form.file = fileList[0] ? fileList[0].raw : ''
    },
    formValidate () {
      return validate(this, this.form)
    }
  }
}
</script>

<style lang="less">
.order-handle-dialog-operate{
    .tip{
        color:#8f8f8f;
    }
    .el-input-group{
        width:200px;
    }

    .form-item{
        padding: 50px 0;
    }
    .upload-demo{
        width: 100%;
        .el-upload-list__item-name{
            white-space: nowrap;
            overflow: hidden;
        }
    }
}

</style>
